const PROCESO = process.env.REACT_APP_MODALIDAD || "UNJBG";
const NOMBRE_SISTEMA = "EXAMEN DE ADMISIÓN";

const TITLE_SISTEMA_SHORT = "SIAD Asistencia";

export { PROCESO, NOMBRE_SISTEMA, TITLE_SISTEMA_SHORT };
